import { createSlice, PayloadAction } from '@reduxjs/toolkit';


interface AgentFilters {
  agentsFilters: {
    category: string[];
    role: string[];
    cloudProvider: string[];
    showOnlyGoldRating: boolean;
  };
}

const agentsFiltersInitialState = () => ({
  category: [],
  role: [],
  cloudProvider: [],
  showOnlyGoldRating: false,
});

const initialState: AgentFilters = {
  agentsFilters: agentsFiltersInitialState(),
};

export const agentsFiltersSlice = createSlice({
  name: 'agentsFilters',
  initialState,
  reducers: {
    setAgentsFiletrs: (state, action: PayloadAction<Partial<AgentFilters['agentsFilters']>>) => {
      state.agentsFilters = {
        ...state.agentsFilters,
        ...action.payload,
      };
    },
    resetAgentsFilters: (state) => {
      state.agentsFilters = agentsFiltersInitialState();
    },
  },
});

export const { setAgentsFiletrs, resetAgentsFilters } = agentsFiltersSlice.actions;
export default agentsFiltersSlice.reducer;
